import React, {
  FC, useEffect, useState,
} from 'react';
import { parseUrlParams } from '../../../lib/utils/utils';
import { getFoodifoxDataLazy } from '../../../lib/axios/FoodifoxDataAPI';
import { Cab, Order, User, Ads3pdVO } from '../../../lib/types';
import QRCode from './QRCode';
import OpenBoxSuccess from './OpenBoxSuccess';
import Loading from '../../../components/Loading';
import FreeTimeExpiredModal from './FreeTimeExpiredModal';
import OrderCheckoutModal from './OrderCheckoutModal';
import SelectPaymentMethodModal from './SelectPaymentMethodModal';

const FetchCode: FC<Props> = ({ isDarkMode }) => {
  const params = parseUrlParams<{ orderId: string }>(window.location.href);
  const [isEnglish, setIsEnglish] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [order, setOrder] = useState<Order>();
  const [cab, setCab] = useState<Cab>();
  const [user, setUser] = useState<User>();
  // 广告列表
  const [adsList, setAdsList] = useState<Ads3pdVO[]>();
  const [showAdsSeconds, setShowAdsSeconds] = useState<number>();
  const [isOpenSuccess, setIsOpenSuccess] = useState<boolean>(false);
  const [skipAdsSeconds, setSkipAdsSeconds] = useState<number>();
  // 免费时间过期
  const [showFreeTimeExpiredModal, setShowFreeTimeExpiredModal] = useState<boolean>(false);
  // 订单结算
  const [showOrderCheckoutModal, setShowOrderCheckoutModal] = useState<boolean>(false);
  // 选择支付方式：银行卡、微信、支付宝、苹果支付、谷歌支付
  const [showSelectPaymentMethodModal, setShowSelectPaymentMethodModal] = useState<boolean>(false);

  const [getCode] = getFoodifoxDataLazy<{ order: Order; cab: Cab; userVO: User; adsList: Ads3pdVO[]; showAdsSeconds: number; skipAdsSeconds: number }>('/foxH5FetchCode/getCode?orderId=' + params.orderId);

  useEffect(() => {
    setLoading(true);
    getCode({
      onError() {
        setLoading(false);
      },
      onCompleted: ({ order, cab, userVO, adsList, showAdsSeconds, skipAdsSeconds }) => {
        setLoading(false);
        setOrder(order);
        setCab(cab);
        setUser(userVO);
        setAdsList(adsList);
        setShowAdsSeconds(showAdsSeconds);
        setSkipAdsSeconds(skipAdsSeconds);

        if (order.orderStatus === 7) {
          setIsOpenSuccess(true);
        }
      },
    });
  }, []);

  return (
    <>
      {
        // 免费时间过期
        showFreeTimeExpiredModal && (
          <FreeTimeExpiredModal
            onClose={() => setShowFreeTimeExpiredModal(false)}
            onConfirm={() => setShowOrderCheckoutModal(true)}
            isEnglish={isEnglish}
          />
        )
      }
      {
        // 订单结算
        showOrderCheckoutModal && (
          <OrderCheckoutModal
            onClose={() => setShowOrderCheckoutModal(false)}
            onConfirm={() => setShowSelectPaymentMethodModal(false)}
            isEnglish={isEnglish}
          />
        )
      }
      {
        // 选择支付方式：银行卡、微信、支付宝、苹果支付、谷歌支付
        showSelectPaymentMethodModal && (
          <SelectPaymentMethodModal
            onClose={() => setShowSelectPaymentMethodModal(false)}
            onConfirm={() => setShowSelectPaymentMethodModal(false)}
            isEnglish={isEnglish}
          />
        )
      }
      {
        (loading) && (
          <Loading />
        )
      }

      {
        !isOpenSuccess && order && cab && adsList && showAdsSeconds != null && skipAdsSeconds != null && (
          <QRCode
            order={order}
            cab={cab}
            user={user}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setIsOpenSuccess={setIsOpenSuccess}
            isShowAds={adsList.some(a => a.appType === 'html5')}
            adsList={adsList.filter(a => a.appType === 'html5')}
            setAdsList={setAdsList}
            showAdsSeconds={showAdsSeconds}
            skipAdsSeconds={skipAdsSeconds}
            isDarkMode={isDarkMode}
          />
        )
      }

      {
        isOpenSuccess && order && cab && (
          <OpenBoxSuccess
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setLoading}
            orderIds={[order.orderId]}
            boxNumbers={[order.boxNumber]}
            completionAdsList={adsList?.filter(a => a.appType === 'html5_completion') || []}
            deviceCode={user?.deviceCode}
            phoneNumber={user?.phoneNumber}
          />
        )
      }
    </>
  );
};

export interface Props {
  isDarkMode: boolean;
}

export default FetchCode;
